import React from 'react'
import { NavLink } from 'react-router-dom'
import img1 from '../../src/images/img1.JPG'

export default function Home() {
    return (
        <div>
            <section id="header" className="d-flex align-items-center">
            <div className="containter-fluid">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row">
                            <div className="col-md-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex justify-content-center flex-column">
                                <h1>Grow with <strong className="brand-name">Arnican</strong></h1>
                                <h4 className="my-3">
                                    We specialise in financial management services
                                </h4>
                                <div className="mt-3">
                                    <NavLink to="/services" className="btn-get-started">Get Started</NavLink>
                                </div>
                            </div>

                            <div className="col-lg-6 pt-5 pt-lg-0 order-1 order-lg-2 header-img">
                                <img src={img1} alt="img"  className="img-fluid animated"/>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            </section>            
        </div>
    )
}
